import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '../../../hooks/useNavigate';
import { MButton } from '../../../horizon-components/MButton/ui/MButton';
import './CourseAsideCard.scss';

interface CourseAsideCardProps {
  className?: string;
  title?: string;
  url?: string;
  children: React.ReactNode;
  data?: React.ReactNode;
}

export const CourseAsideCard = ({
  className,
  title,
  url,
  children,
  data,
}: CourseAsideCardProps) => {
  const { t } = useTranslation(['translation']);
  const navigate = useNavigate();
  const goTo = () => url && navigate(url);

  return (
    <div className={classNames('CourseAsideCard', className)}>
      {!!(title || url || data) && (
        <div className="CourseAsideCard__head">
          {!!(title || data) && <h4>{title}</h4>}

          {!!url && (
            <MButton variant="highlighted" color="white" onClick={goTo}>
              {t('buttons.view_all')}
            </MButton>
          )}
          {!!data && data}
        </div>
      )}

      {children}
    </div>
  );
};
